import script from "./ViewLessonSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewLessonSidebar.vue?vue&type=script&setup=true&lang=js"

import "./ViewLessonSidebar.vue?vue&type=style&index=0&id=26fba2ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26fba2ac"]])

export default __exports__